import React, { useContext, useEffect, createContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import { getRouterBase } from "./common/utils";
import { setLocale } from "./store/actions/locale";
import { getUserGeoInfo } from "./store/actions/user";
import { StoreContext } from "./store/store";
import { loadOneTrustSnippet } from "./common/utils";

const PreferencesLayout = React.lazy(() => import("./components/Layouts/PreferencesLayout"));
const AccountLayout = React.lazy(() => import("./components/Layouts/AccountLayout"));
const SUPPORTED_LOCALES = require("../config/config").SUPPORTED_LOCALES;
const UnibrowContext = createContext();
export const useUnibrowContext = () => {
    return useContext(UnibrowContext);
};
const App = (props) => {
    const { state, dispatch } = useContext(StoreContext);
    const [showUnibrow, setShowUnibrow] = useState(false);
    const { t, i18n } = useTranslation();
    useEffect(() => {
        setLocale(dispatch, i18n.language);
        getUserGeoInfo(dispatch);
        document.documentElement.setAttribute(
            "lang",
            SUPPORTED_LOCALES.includes(i18n.language) ? i18n.language : "en-us"
        );
        loadOneTrustSnippet();
    }, []);

    return (
        <Router basename={getRouterBase()}>
            <UnibrowContext.Provider value={{ showUnibrow, setShowUnibrow }}>
                <Switch>
                    <Route path="/preferences" component={PreferencesLayout} />
                    <Route path="/account" component={AccountLayout} />
                </Switch>
            </UnibrowContext.Provider>
        </Router>
    );
};

export default App;
